<div class="flex flex-col gap-2">
  <p class="text-sm text-shikenso-purple-base-60 mb-3" data-testid="campaign-details-observations-description">
    {{ 'pages.campaignDetails.observations.description' | translate }}
  </p>

  <span class="text-sm mb-1">
    {{ 'pages.campaignDetails.observations.filters.title' | translate }}
  </span>

  <div class="flex flex-wrap items-center gap-4 pl-1">
    <app-campaign-details-deliverables-filter-select
      class="w-[252px]"
      [emptyLabel]="observationTypeEmptyLabel()"
      [loading]="isContentLoading()"
      [options]="filterOptions().observationTypes"
      [showBulkActions]="true"
      [showSearch]="false"
      [selectedValues]="filterState().observationTypes"
      (selectionChanged)="onObservationTypesChanged($event)"
    />
  </div>

  <div class="flex items-center justify-between w-full gap-4 pl-2 mb-1">
    @if (campaignExportConfig().showObservationsStatusFilter) {
      <div class="flex flex-col overflow-hidden">
        <div class="flex items-center gap-6">
          <span class="text-xs text-shikenso-purple-base-60">
            {{ 'pages.campaignDetails.observations.filters.observationStatus' | translate }}
          </span>

          <app-campaign-details-deliverables-status-filters
            [loaderCount]="2"
            [loading]="isContentLoading()"
            [selectedStatuses]="filterState().observationStatuses"
            [statusOptions]="visibleStatusOptions()"
            (selectedStatusesChanged)="onObservationStatusesChanged($event)"
          />
        </div>
      </div>
    }

    <app-campaign-details-deliverables-group-toggle
      [checked]="groupByContent()"
      (checkedChanged)="onGroupByContentChanged($event)"
    />
  </div>

  <app-campaign-details-observations-table
    #tableRef
    [campaignExportConfig]="campaignExportConfig()"
    [groupedMode]="groupByContent()"
    [groupedRowData]="groupedRows()"
    [loading]="isContentLoading()"
    [rowData]="filteredRows()"
    (rowClicked)="onObservationRowClicked($event)"
  />
</div>
